import { render, staticRenderFns } from "./ContinentDialog.vue?vue&type=template&id=6cc6dff1"
import script from "./ContinentDialog.vue?vue&type=script&lang=ts"
export * from "./ContinentDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports